import AGENDA_PRO_API from '@agendapro/agendapro_api';

const ADMIN_BASE_PATH = '/bizops-ai-agents-back/api/v1/admin';

const redirect = new URLSearchParams(window.location.href).toString().slice(0, -1);

const API = new AGENDA_PRO_API({
	urlBase: `${process.env.BUSINESS_AP_API}${ADMIN_BASE_PATH}`,
	cognitoUrl: `${process.env.BUSINESS_AP_API}/agendapro-backend`,
	cognitoApiGatewayUrls: ['/api/views/admin/v1/companies/company_setting'],
	useCamelCase: true,
	cognitoRefreshDomain: `${process.env.BUSINESS_API_URL_V1}`.replace('/api/views/admin/v1', ''),
	redirectUrls: {
		401: `${process.env.BUSINESS_USERS_API}?redirect=${redirect}`,
	},
}).AXIOS_INSTANCE.axiosInstance;

export default API;
